import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { IconClose } from 'design-system/icons/IconClose';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { ToastModal } from 'design-system/ToastModal';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const ReferenceCopiedToast = ({ isVisible, onClose, withPaddingHorizontal, bottom, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<ToastModal isVisible={isVisible} position="bottom" style={[
            styles.modal,
            withPaddingHorizontal && styles.modalWithPadding,
            bottom ? { bottom } : undefined,
        ]} onCloseAction={onClose}>
      <View style={styles.toastTextContainer}>
        <Text TextThin-16 White>
          Copied reference number
        </Text>
      </View>
      <TouchableBounce style={styles.closeIcon} onPress={onClose}>
        <IconClose alt color={colors.elements.white}/>
      </TouchableBounce>
    </ToastModal>);
};
const styleSet = createStyleSheets((colors) => ({
    modal: {
        width: '100%',
        bottom: '100%',
        height: 'auto',
        marginBottom: rem(8),
        paddingHorizontal: 0,
    },
    closeIcon: {
        backgroundColor: colors.background.transparent,
        borderRadius: rem(8),
        padding: rem(4),
    },
    toastTextContainer: {
        flex: 1,
    },
    modalWithPadding: {
        paddingHorizontal: rem(16),
    },
}));
export default ReferenceCopiedToast;
